module.exports = __webpack_public_path__ + "static/img/far1_active.8332dea7.jpg";